// Order/OrderTemplate.tsx

import React, {useContext, useEffect, useState} from 'react';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import {Message} from 'Core/components/Message';
import {useTheme} from 'Theme/ThemeContext';
import {AuthContext, AuthContextType} from 'Auth/AuthContext';
import CircularProgress from 'Core/components/elements/CircularProgress';
import {headerHeight} from 'Core/components/Header/Header';
import {redirectWithNextBack} from "../../Utils/redirectNext";
import {FC} from "WideLayout/Layouts";
import Head from "Core/components/Head";
import {DOMAIN_URL} from "Auth/axiosConfig";

const OrderTemplate: React.FC = () => {
    const {isAuthenticated} = useContext(AuthContext) as AuthContextType;
    const navigate = useNavigate();
    const location = useLocation();
    const {plt} = useTheme();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (isAuthenticated === false) {
            redirectWithNextBack(navigate, location, '/auth');
            Message.info('Мы сохранили ваш выбор, войдите или зарегистрируйтесь для продолжения.', 1, 9000);
        } else setLoading(false);
    }, [isAuthenticated, navigate, location]);


    if (loading) return <CircularProgress size={'150px'}/>;

    return (
        <><Head
            title={'Заказ | Лайф Хелп'}
            description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
            robots={'noindex, nofollow'}
            canonicalUrl={`${DOMAIN_URL}/order`}/><FC px={2} mx={'auto'} pos={'relative'} maxW={'800px'}
                                                      maxH={`calc(100vh - ${headerHeight}px)`}>
            <Outlet/>
        </FC></>
    );
};

export default OrderTemplate;
